import React from 'react';
import cx from 'classnames';
import { PropTypes } from 'prop-types';
import { Icon } from '@unite-us/app-components';

const PrimaryButton = ({
  ariaLabel,
  className,
  dataTestId,
  disabled,
  icon,
  label,
  onClick,
}) => (
  <button
    className={cx(
      className,
      'flex p-2 border border-solid bg-action-blue rounded space-x-2',
      disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-text-blue',
    )}
    data-testid={dataTestId}
    type="button"
    aria-label={ariaLabel || label}
    onClick={onClick}
    disabled={disabled}
  >
    {icon ? (
      <Icon
        icon={icon}
        color="white"
        className={cx(disabled && 'opacity-50')}
      />
    ) : null}
    <span className={cx('text-white', disabled && 'opacity-50')}>
      {label}
    </span>
  </button>
);

PrimaryButton.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

PrimaryButton.defaultProps = {
  ariaLabel: '',
  className: '',
  disabled: false,
  icon: '',
  dataTestId: null,
};

export default PrimaryButton;
